import {KEY, STATUS_CLIENT} from "./reducer";

export const getState = (state) => state[KEY];

export const isLoggedIn = (state) => getState(state) === STATUS_CLIENT;
